import React, {useState} from 'react';
import { get, isEmpty } from 'lodash';
import classNames from 'classnames';

// Local Dependencies
import { MemberCommunicationSettings } from 'ui/containers/MemberCommunicationSettings';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { memberAddEditAddresspreloader as MemberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { checkbox as Checkbox } from 'ui/views/generic/checkbox';
import { toggleField as ToggleField } from 'ui/views/generic/toggleField';
import * as errorOverlay from 'utils/errorOverlay';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import {  SIZES } from 'constants/common';
import { errorOverlay as ErrorOverlay } from 'ui/views/widgets/errorOverlay';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberInfoCommunicationSettingsPhone as MemberInfoCommunicationSettingsPhone } from 'ui/views/widgets/memberInfoCommunicationSettingsPhone';
 *
 * // render
 * <MemberInfoCommunicationSettingsPhone propName='propValue'/>
 */
export const _memberInfoCommunicationSettingsPhone = ( props ) => {
    const { showCustomErrorView = false, description } = props;
    const [flagvalue,setFlagValue] = useState(props?.updateMemberPreferencesRequest?.member?.channelPreferences?.communicationChannels?.find(obj => obj.channel?.channelName == "CALL")?.optedIn)
    const restricted = props?.updateMemberPreferencesRequest?.member?.channelPreferences?.communicationChannels?.find(obj => obj.channel?.channelName == "CALL")?.restricted
   
    // check if we need to disable the checkbox for set communication preference
    const isSetCommunicationPreferenceDisabled = isEmpty( props.contacts );

    // if contacts are empty set checkbox to disable
    const communicationPreferenceTitleClassName = classNames( 'ui-member-communication-settings__communication-preference__title', {
        'ui-member-communication-settings__communication-preference__title--disabled': isSetCommunicationPreferenceDisabled
    } );

    // const displaytoggle = (!restricted || props?.requestPayload?.context?.patientid)? false:true;

    const displaytoggle = (!restricted && props?.memberChannelPreferences)? true:false;
    
    if( showCustomErrorView ) {
		return (
			<div className="ui-member-info-communication-settings-phone">
 				<div className='ui-member-info-communication-settings-phone__icon'>
                    <Icon name='warningBlue' width={ 50 } height={ 50 } />
                </div>

				{/* sub-title */}
                <p className='ui-member-info-communication-settings-phone__title'>
                    { description }
                </p>

		</div>
		);
	}
    

    return (
        <div className='ui-member-communication-settings'>
            {/* if we have action only then the checkbox action of set communication preference should show */}
            { !isEmpty( get( props, 'communicationPreferenceAction.title', {} ) ) ?

            // set communication Preference
            <div className= 'ui-member-communication-settings__communication-preference'>
            
            {/* ToggleField */}

            {displaytoggle &&  <ToggleField
                    onChange = {  ( event ) => {
const channelCommunication=props;
// eslint-disable-next-line no-shadow, eqeqeq
channelCommunication.updateMemberPreferencesRequest.member.channelPreferences.communicationChannels.find( channelCommunication => 'CALL' == channelCommunication.channel.channelName ).optedIn = !flagvalue;
const channelObj= channelCommunication.updateMemberPreferencesRequest.member.channelPreferences.communicationChannels;
const channelcheck=false === channelObj[ 0 ].optedIn && false === channelObj[ 1 ].optedIn && false === channelObj[ 2 ].optedIn ?true:false ;
if (channelcheck) {
	pageLevelPreloader.hide();
	setFlagValue(flagvalue);
    
	//<ErrorOverlay message={'errorMessage'} size={SIZES.SMALL} />;
    errorOverlay.open( { message: 'Please opt-in at least one channel' , size: SIZES.SMALL } );
    return;
} else {
	setFlagValue(!flagvalue);
	event.stopPropagation();
	props.onSetCommunicationPreferenceClick({
		updateMemberPreferencesRequest: props.updateMemberPreferencesRequest,
		communicationPreferenceFlag: !flagvalue,
	});
}
                } }
 
                className = { 'ui-hsa-fsa-indicator__toggle' }
                height = { 12 }
                width = { 20 }
                value = {flagvalue}
            />}

                       {/* Check box */}
               
               {/*<Checkbox
                    value={flagvalue}
                    size='xs'
                    disabled = { isSetCommunicationPreferenceDisabled }
                    className = { isSetCommunicationPreferenceDisabled ? 'ui-member-communication-settings__communication-preference__checkbox--disabled' : null }
                    onClick={ ( event ) => {
                        setFlagValue(!flagvalue)
                        event.stopPropagation();
                        props.onSetCommunicationPreferenceClick( {
                            updateMemberPreferencesRequest: props.updateMemberPreferencesRequest,
                            communicationPreferenceFlag: !flagvalue
                        } );
                    } }
                />*/}

                {/* title */}
                
                { displaytoggle && <p
                    className={ communicationPreferenceTitleClassName }
                    onClick={ isSetCommunicationPreferenceDisabled ? null : ( event ) => {
                        event.stopPropagation();
                        props.onSetCommunicationPreferenceClick( {
                            communicationPreferenceFlag: !( get( props, 'communicationPreferenceFlag', false ) )
                        } );
                    } }
                >                  
                    { getLabel( get( props,!displaytoggle ? '' : 'communicationPreferenceAction.title', {} ) )  }
                 </p>
}
               
            </div> : null }
            <MemberCommunicationSettings
                { ...props }
            />
        </div>
    );
};

// set display name
_memberInfoCommunicationSettingsPhone.displayName = 'memberInfoCommunicationSettingsPhone';

// set default props
_memberInfoCommunicationSettingsPhone.defaultProps = {};

// prop types
_memberInfoCommunicationSettingsPhone.propTypes = {};

/**---------------------------- */

// Preloader
export const memberInfoCommunicationSettingsPhonePreloader = ( ) => {
    return (
        <div className='ui-member-info-communication-settings-phone-preloader'>
            <MemberAddEditAddresspreloader hideTitle={ true } />
        </div>
    );
};

// set display name
memberInfoCommunicationSettingsPhonePreloader.displayName = 'memberCommunicationSettingsPreloader';

// set default props
memberInfoCommunicationSettingsPhonePreloader.defaultProps = {};

// prop types
memberInfoCommunicationSettingsPhonePreloader.propTypes = {};

export const memberInfoCommunicationSettingsPhone = withNetworkState( memberInfoCommunicationSettingsPhonePreloader, _memberInfoCommunicationSettingsPhone );
